import { useSession, useOptionalSession } from './chunk-7QYYSJGW.js';
import * as React from 'react';
import { createLogger } from '@authe/fe-commons/logging';
import { jsx, Fragment } from 'react/jsx-runtime';
import { sessionIdentityKey } from '@authe/fe-commons/session';

var log = createLogger("ui-core:session");
function useRequireSessionLogin(manager, enabled, options = {}) {
  const { returnTo, params, onAuthenticated } = options;
  const [state, setState] = React.useState({ phase: "idle", error: null });
  const paramsKey = params ? JSON.stringify(params) : "";
  const onAuthenticatedRef = React.useRef(onAuthenticated);
  onAuthenticatedRef.current = onAuthenticated;
  const paramsRef = React.useRef(params);
  paramsRef.current = params;
  React.useEffect(() => {
    if (!enabled) {
      setState({ phase: "idle", error: null });
      return void 0;
    }
    let active = true;
    setState({ phase: "pending", error: null });
    void manager.requireSession({ returnTo, params: paramsRef.current }).then((result) => {
      if (!active) return;
      if (result.outcome === "blocked") {
        setState({ phase: "blocked", error: result.error.message });
      } else if (result.outcome === "authenticated") {
        onAuthenticatedRef.current?.();
      }
    }).catch((err) => {
      if (!active) return;
      log.error("requireSession failed", { error: String(err) });
      setState({ phase: "blocked", error: err instanceof Error ? err.message : String(err) });
    });
    return () => {
      active = false;
    };
  }, [manager, enabled, returnTo, paramsKey]);
  return state;
}
function RequireSession({
  children,
  loading = null,
  blocked = null,
  error,
  returnTo,
  loginParams
}) {
  const { state, manager } = useSession();
  const login = useRequireSessionLogin(manager, state.status === "unauthenticated", {
    returnTo,
    params: loginParams
  });
  if (state.status === "authenticated") return /* @__PURE__ */ jsx(Fragment, { children });
  if (login.phase === "blocked" || state.status === "error") return /* @__PURE__ */ jsx(Fragment, { children: error ?? blocked });
  return /* @__PURE__ */ jsx(Fragment, { children: loading });
}
function useSessionIdentityKey() {
  const session = useOptionalSession()?.session;
  return session ? sessionIdentityKey(session) : void 0;
}

export { RequireSession, useRequireSessionLogin, useSessionIdentityKey };
//# sourceMappingURL=chunk-ZS2NGWTG.js.map
//# sourceMappingURL=chunk-ZS2NGWTG.js.map